export default __webpack_public_path__ + "locales/az/EmbeddingPanel.json?hash=09bd78a89475104fbee1b5e8f1e2fdca";